(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["juha-collection"] && !Shopify.designMode) return;
  try {
    
window.juhaCollectionLook = [
  {
    "look": 1,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_1_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_1_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_1_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240302",
        "name": "CROPPED DOUBLE TAILORED JACEKT",
        "color": "STRIPE"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10240802",
        "name": "EXTREME WIDE EASY PANTS",
        "color": "STRIPE"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 2,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_2_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_2_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_2_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240301-2",
        "name": "OVERSIZED CHECK JACKET",
        "color": "BROWN"
      },
      {
        "id": "No.10240202-2",
        "name": "CHECK RAGLAN BOMBER JACKET",
        "color": "BROWN"
      },
      {
        "id": "No.10240702-1",
        "name": "DRAPED RAYON SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10240801-3",
        "name": "CHECK WIDE EASY PANTS",
        "color": "BROWN"
      },
      {
        "id": "No.10240901",
        "name": "FORMED OVAL BELT",
        "color": "GOLD"
      }
    ]
  },
  {
    "look": 3,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_3_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_3_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_3_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240605",
        "name": "LUSH VELOUR SECOND SKIN",
        "color": "BROWN"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10240804",
        "name": "EASED NARROW SLACKS",
        "color": "BLACK"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 4,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_4_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_4_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_4_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240701-1",
        "name": "FANCY TWEED JACKET",
        "color": "BLACK"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10240806",
        "name": "VELOUR SECOND SKIN HALF LEGGINGS",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 5,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_5_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_5_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_5_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240502",
        "name": "STRUCTURED TURTLENECK KNIT",
        "color": "RED"
      },
      {
        "id": "No.10240801-1",
        "name": "2TUCK WIDE EASY PANTS",
        "color": "GRAY"
      },
      {
        "id": "No.10240801-1",
        "name": "2TUCK WIDE EASY PANTS",
        "color": "BLACK"
      },
      {
        "id": "No.10240901",
        "name": "FORMED OVAL BELT",
        "color": "SILVER"
      }
    ]
  },
  {
    "look": 6,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_6_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_6_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_6_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240702-4",
        "name": "LIGHTWEIGHT OMBRE CHECK SHIRT",
        "color": "BEIGE"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10240805-3",
        "name": "FORMED WIDE CORDUROY PANTS",
        "color": "BROWN"
      },
      {
        "id": "No.10240901",
        "name": "FORMED OVAL BELT",
        "color": "GOLD"
      }
    ]
  },
  {
    "look": 7,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_7_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_7_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_7_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240102",
        "name": "BELTED OVER COAT",
        "color": "GRAY"
      },
      {
        "id": "No.10240201",
        "name": "SOFT FORM RIDERS JACKET",
        "color": "BLACK"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10240802",
        "name": "EXTREME WIDE EASY PANTS",
        "color": "CHECK"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 8,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_8_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_8_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_8_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240602-1",
        "name": "INTERLOCK HENLEY L/S",
        "color": "ECRU"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10240804",
        "name": "EASED NARROW SLACKS",
        "color": "CHECK"
      }
    ]
  },
  {
    "look": 9,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_9_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_9_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_9_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240501",
        "name": "COLLARED ARGYLE CARDIGAN",
        "color": "BLACK"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10240805-1",
        "name": "FORMED WIDE DENIM (FADED WASH)",
        "color": "DUSTY BLUE"
      }
    ]
  },
  {
    "look": 10,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_10_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_10_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_10_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240101",
        "name": "SOFT CHARME CHESTER COAT",
        "color": "NAVY"
      },
      {
        "id": "No.10240701-1",
        "name": "FANCY TWEED JACKET",
        "color": "NAVY"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10240806",
        "name": "VELOUR SECOND SKIN HALF LEGGINGS",
        "color": "BLACK"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 11,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_11_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_11_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_11_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240301-1",
        "name": "OVERSIZED CORDUROY JACKET",
        "color": "BLACK"
      },
      {
        "id": "No.10240605",
        "name": "LUSH VELOUR SECOND SKIN",
        "color": "BLACK"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10240805-3",
        "name": "FORMED WIDE CORDUROY PANTS",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 12,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_12_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_12_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_12_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10240801-1",
        "name": "2TUCK WIDE EASY PANTS",
        "color": "BROWN"
      },
      {
        "id": "No.10240801-3",
        "name": "CHECK WIDE EASY PANTS",
        "color": "BEIGE"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      },
      {
        "id": "No.10240901",
        "name": "FORMED OVAL BELT",
        "color": "GOLD"
      }
    ]
  },
  {
    "look": 13,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_13_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_13_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_13_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10240702-4",
        "name": "LIGHTWEIGHT OMBRE CHECK SHIRT",
        "color": "BEIGE"
      },
      {
        "id": "No.10240805-3",
        "name": "FORMED WIDE CORDUROY PANTS",
        "color": "BLACK"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      },
      {
        "id": "No.10240901",
        "name": "FORMED OVAL BELT",
        "color": "GOLD"
      }
    ]
  },
  {
    "look": 14,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_14_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_14_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_14_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240702-3",
        "name": "SOFT VELOUR SHIRT",
        "color": "RED"
      },
      {
        "id": "No.10240502",
        "name": "STRUCTURED TURTLENECK KNIT",
        "color": "RED"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10240801-2",
        "name": "SOFT VELOUR WIDE PANTS",
        "color": "RED"
      },
      {
        "id": "No.10240901",
        "name": "FORMED OVAL BELT",
        "color": "GOLD"
      }
    ]
  },
  {
    "look": 15,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_15_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_15_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_15_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240202-2",
        "name": "CHECK RAGLAN BOMBER JACKET",
        "color": "BEIGE"
      },
      {
        "id": "No.10240501",
        "name": "COLLARED ARGYLE CARDIGAN",
        "color": "NAVY"
      },
      {
        "id": "No.10240502",
        "name": "STRUCTURED TURTLENECK KNIT",
        "color": "NAVY"
      },
      {
        "id": "No.10240805-2",
        "name": "FORMED WIDE DENIM (ONE WASH)",
        "color": "INDIGO"
      }
    ]
  },
  {
    "look": 16,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_16_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_16_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_16_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240301-2",
        "name": "OVERSIZED CHECK JACKET",
        "color": "BEIGE"
      },
      {
        "id": "No.10240202-2",
        "name": "CHECK RAGLAN BOMBER JACKET",
        "color": "BEIGE"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10240806",
        "name": "VELOUR SECOND SKIN HALF LEGGINGS",
        "color": "BLACK"
      },
      {
        "id": "No.10240901",
        "name": "FORMED OVAL BELT",
        "color": "GOLD"
      }
    ]
  },
  {
    "look": 17,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_17_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_17_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_17_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240201",
        "name": "SOFT FORM RIDERS JACKET",
        "color": "BLACK"
      },
      {
        "id": "No.10240702-4",
        "name": "LIGHTWEIGHT OMBRE CHECK SHIRT",
        "color": "GRAY"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10240802",
        "name": "EXTREME WIDE EASY PANTS",
        "color": "STRIPE"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 18,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_18_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_18_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_18_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240301-1",
        "name": "OVERSIZED CORDUROY JACKET",
        "color": "BROWN"
      },
      {
        "id": "No.10240201",
        "name": "SOFT FORM RIDERS JACKET",
        "color": "BROWN"
      },
      {
        "id": "No.10240702-4",
        "name": "LIGHTWEIGHT OMBRE CHECK SHIRT",
        "color": "BEIGE"
      },
      {
        "id": "No.10240502",
        "name": "STRUCTURED TURTLENECK KNIT",
        "color": "RED"
      },
      {
        "id": "No.10240803",
        "name": "FLUID FLARE PANTS",
        "color": "GRAY"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 19,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_19_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_19_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_19_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240204-1",
        "name": "FANCY TWEED IKE JACKET",
        "color": "NAVY"
      },
      {
        "id": "No.10240702-1",
        "name": "DRAPED RAYON SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10240502",
        "name": "STRUCTURED TURTLENECK KNIT",
        "color": "BLACK"
      },
      {
        "id": "No.10240801-2",
        "name": "SOFT VELOUR WIDE PANTS",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 20,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_20_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_20_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_20_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240302",
        "name": "CROPPED DOUBLE TAILORED JACEKT",
        "color": "CHECK"
      },
      {
        "id": "No.10240604",
        "name": "WASHABLE WOOL TURTLE",
        "color": "GRAY"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10240802",
        "name": "EXTREME WIDE EASY PANTS",
        "color": "CHECK"
      }
    ]
  },
  {
    "look": 21,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_21_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_21_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_21_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240102",
        "name": "BELTED OVER COAT",
        "color": "BLACK"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10240502",
        "name": "STRUCTURED TURTLENECK KNIT",
        "color": "BLACK"
      },
      {
        "id": "No.10240901",
        "name": "FORMED OVAL BELT",
        "color": "SILVER"
      }
    ]
  },
  {
    "look": 22,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_22_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_22_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_22_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240203",
        "name": "SOFT CHARME RIDING JACKET",
        "color": "NAVY"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10240802",
        "name": "EXTREME WIDE EASY PANTS",
        "color": "STRIPE"
      }
    ]
  },
  {
    "look": 23,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_23_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_23_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_23_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240701-2",
        "name": "ALPACA SHAGGY JACKET",
        "color": "IVORY"
      },
      {
        "id": "No.10240605",
        "name": "LUSH VELOUR SECOND SKIN",
        "color": "BROWN"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10240806",
        "name": "VELOUR SECOND SKIN HALF LEGGINGS",
        "color": "BLACK"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 24,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_24_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_24_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026fw_24_1520.jpg"
    },
    "items": [
      {
        "id": "No.10240101",
        "name": "SOFT CHARME CHESTER COAT",
        "color": "RED"
      },
      {
        "id": "No.10240704",
        "name": "EXTENDED COLLAR SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10240502",
        "name": "STRUCTURED TURTLENECK KNIT",
        "color": "BLACK"
      },
      {
        "id": "No.10240802",
        "name": "EXTREME WIDE EASY PANTS",
        "color": "BLACK"
      },
      {
        "id": "No.10240901",
        "name": "FORMED OVAL BELT",
        "color": "GOLD"
      }
    ]
  }
];

    document.addEventListener('DOMContentLoaded', function() {
      var $videoBtn = document.querySelector('.p-juhaCollection__videoPlaybtn');

      if ($videoBtn) {
        $videoBtn.addEventListener('click', function() {
          var $video = document.querySelector('.p-juhaCollection__video');
          var $iframe = $video.querySelector('iframe');

          $video.classList.add('is-play');
          videoControl('playVideo', $iframe);
        });
      }

      function videoControl(action, tgt){
        var $playerWindow = tgt.contentWindow;

        $playerWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
      }

      var collectionHtml = '';
      window.juhaCollectionLook.forEach(function (look) {
        var itemsHtml = '';
        look.items.forEach(function(item) {
          var heading = '';
          if (item.heading) {
            heading = item.heading + '<br>';
          }
          itemsHtml += '<li>' + heading + item.id + '<br>' + item.name + '<br>' + item.color + '</li>';
        });
        collectionHtml += '<div class="p-juhaCollection__item"><div class="p-juhaCollection__pic"><img srcset="' + look.images.small + ' 480w, ' + look.images.medium + ' 800w, ' + look.images.large + ' 1520w" src="' + look.images.large + '" sizes="(max-width:750px) 100vw, (max-width:990px) 50vw, 33vw"></div><div class="p-juhaCollection__info"><div class="p-juhaCollection__body"><ul>' + itemsHtml + '</ul></div></div></div>'
      });
      var $elm = document.getElementById('p-juhaCollection__items');
      $elm.innerHTML = collectionHtml;
    });

  } catch(e) { console.error(e); }
})();
})();
